module.exports = __webpack_public_path__ + "static/product2-b-8ee3bcdf9f346b10ce8efe9e49f20df4.png";